import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import LoadingPage from '../components/Layout/LoadingPage/LoadingPage.component';
import useSessionUser from '../hooks/useSessionUser';
import { assessmentSessionActions } from '../reducers/assessmentSessionReducer/assessmentSessionSlice';
import { AssessmentSessionProcessTypeId } from '../services/exams/assessmentSession/assessments.types';
import { RootState } from '../store';
import { setAssessmentSessionProcess, updateSessionProcesses } from '../utils/assessmentSessionProcess';
import { getAssessmentUrl } from '../utils/routerUrls';

const ExamTaskGroupSolutionRedirector: React.FC = () => {
  const { examTaskGroupSolutionScoreId, assessmentSessionId } = useParams() as {
    examTaskGroupSolutionScoreId: string;
    assessmentSessionId: string;
  };
  const user = useSessionUser();
  const dispatch = useDispatch();
  const assessmentSession = useSelector((state: RootState) => state.assessmentSession.assessmentSession);

  const { reloadAssessmentSession } = useSessionUser();
  const history = useHistory();

  const redirectToAssesmentUrl = async () => {
    if (!assessmentSession || assessmentSession.assessmentSessionId !== assessmentSessionId) {
      const updatedSession = await updateSessionProcesses(assessmentSessionId);
      setAssessmentSessionProcess(updatedSession.assessmentSessionProcesses);
      dispatch(assessmentSessionActions.updateAssessmentSession(updatedSession));
      await reloadAssessmentSession(assessmentSessionId);
    }
    history.replace(
      getAssessmentUrl(assessmentSessionId, AssessmentSessionProcessTypeId.Scoring.toString(), user.user.profile.sub) +
        `?examTaskGroupSolutionScoreId=${examTaskGroupSolutionScoreId}`,
    );
  };

  useEffect(() => {
    redirectToAssesmentUrl();
  }, [examTaskGroupSolutionScoreId, assessmentSessionId]);

  return <LoadingPage message={`Przekierowanie do pracy ID_${examTaskGroupSolutionScoreId}`} />;
};

export default ExamTaskGroupSolutionRedirector;
